<script setup>

import { useStore } from "vuex";
import CategoriesRow from '../components/CategoriesRow.vue';
import { onBeforeMount } from 'vue';
import bootstrap from "bootstrap/dist/js/bootstrap";
import axios from "axios";
import validSession from "../assets/js/valid-session";
import loadGif from "@/assets/img/loading.gif"
import { toast } from 'vue3-toastify';
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

let icons = [];
let selectCategories = {};
let selectCategoriesMove = [];

let icons_new = [
  {
    "name": "Utensils",
    "icon": "utensils",
    "class": "fa-utensils",
    "group": "Alimentação"
  },
  {
    "name": "Coffee",
    "icon": "coffee",
    "class": "fa-coffee",
    "group": "Alimentação"
  },
  {
    "name": "Hamburger",
    "icon": "hamburger",
    "class": "fa-hamburger",
    "group": "Alimentação"
  },
  {
    "name": "Pizza Slice",
    "icon": "pizza-slice",
    "class": "fa-pizza-slice",
    "group": "Alimentação"
  },
  {
    "name": "Apple Alt",
    "icon": "apple-alt",
    "class": "fa-apple-alt",
    "group": "Alimentação"
  },
  {
    "name": "Carrot",
    "icon": "carrot",
    "class": "fa-carrot",
    "group": "Alimentação"
  },
  {
    "name": "Ice Cream",
    "icon": "ice-cream",
    "class": "fa-ice-cream",
    "group": "Alimentação"
  },
  {
    "name": "Lemon",
    "icon": "lemon",
    "class": "fa-lemon",
    "group": "Alimentação"
  },
  {
    "name": "Fish",
    "icon": "fish",
    "class": "fa-fish",
    "group": "Alimentação"
  },
  {
    "name": "Bread Slice",
    "icon": "bread-slice",
    "class": "fa-bread-slice",
    "group": "Alimentação"
  },
  {
    "name": "Egg",
    "icon": "egg",
    "class": "fa-egg",
    "group": "Alimentação"
  },
  {
    "name": "Cheese",
    "icon": "cheese",
    "class": "fa-cheese",
    "group": "Alimentação"
  },
  {
    "name": "Hotdog",
    "icon": "hotdog",
    "class": "fa-hotdog",
    "group": "Alimentação"
  },
  {
    "name": "Drumstick Bite",
    "icon": "drumstick-bite",
    "class": "fa-drumstick-bite",
    "group": "Alimentação"
  },
  {
    "name": "Wine Bottle",
    "icon": "wine-bottle",
    "class": "fa-wine-bottle",
    "group": "Alimentação"
  },
  {
    "name": "Wine Glass",
    "icon": "wine-glass",
    "class": "fa-wine-glass",
    "group": "Alimentação"
  },
  {
    "name": "Beer",
    "icon": "beer",
    "class": "fa-beer",
    "group": "Alimentação"
  },
  {
    "name": "Cocktail",
    "icon": "cocktail",
    "class": "fa-cocktail",
    "group": "Alimentação"
  },
  {
    "name": "Glass Martini",
    "icon": "glass-martini",
    "class": "fa-glass-martini",
    "group": "Alimentação"
  },
  {
    "name": "Mug Hot",
    "icon": "mug-hot",
    "class": "fa-mug-hot",
    "group": "Alimentação"
  },
  {
    "name": "Car",
    "icon": "car",
    "class": "fa-car",
    "group": "Transporte"
  },
  {
    "name": "Bus",
    "icon": "bus",
    "class": "fa-bus",
    "group": "Transporte"
  },
  {
    "name": "Bicycle",
    "icon": "bicycle",
    "class": "fa-bicycle",
    "group": "Transporte"
  },
  {
    "name": "Motorcycle",
    "icon": "motorcycle",
    "class": "fa-motorcycle",
    "group": "Transporte"
  },
  {
    "name": "Plane",
    "icon": "plane",
    "class": "fa-plane",
    "group": "Transporte"
  },
  {
    "name": "Train",
    "icon": "train",
    "class": "fa-train",
    "group": "Transporte"
  },
  {
    "name": "Ship",
    "icon": "ship",
    "class": "fa-ship",
    "group": "Transporte"
  },
  {
    "name": "Subway",
    "icon": "subway",
    "class": "fa-subway",
    "group": "Transporte"
  },
  {
    "name": "Gas Pump",
    "icon": "gas-pump",
    "class": "fa-gas-pump",
    "group": "Transporte"
  },
  {
    "name": "Taxi",
    "icon": "taxi",
    "class": "fa-taxi",
    "group": "Transporte"
  },
  {
    "name": "Truck",
    "icon": "truck",
    "class": "fa-truck",
    "group": "Transporte"
  },
  {
    "name": "Helicopter",
    "icon": "helicopter",
    "class": "fa-helicopter",
    "group": "Transporte"
  },
  {
    "name": "Charging Station",
    "icon": "charging-station",
    "class": "fa-charging-station",
    "group": "Transporte"
  },
  {
    "name": "Map",
    "icon": "map",
    "class": "fa-map",
    "group": "Transporte"
  },
  {
    "name": "Road",
    "icon": "road",
    "class": "fa-road",
    "group": "Transporte"
  },
  {
    "name": "Parking",
    "icon": "parking",
    "class": "fa-parking",
    "group": "Transporte"
  },
  {
    "name": "Street View",
    "icon": "street-view",
    "class": "fa-street-view",
    "group": "Transporte"
  },
  {
    "name": "Walking",
    "icon": "walking",
    "class": "fa-walking",
    "group": "Transporte"
  },
  {
    "name": "Traffic Light",
    "icon": "traffic-light",
    "class": "fa-traffic-light",
    "group": "Transporte"
  },
  {
    "name": "Shuttle Van",
    "icon": "shuttle-van",
    "class": "fa-shuttle-van",
    "group": "Transporte"
  },
  {
    "name": "Home",
    "icon": "home",
    "class": "fa-home",
    "group": "Moradia"
  },
  {
    "name": "Bed",
    "icon": "bed",
    "class": "fa-bed",
    "group": "Moradia"
  },
  {
    "name": "Couch",
    "icon": "couch",
    "class": "fa-couch",
    "group": "Moradia"
  },
  {
    "name": "Bath",
    "icon": "bath",
    "class": "fa-bath",
    "group": "Moradia"
  },
  {
    "name": "Toilet",
    "icon": "toilet",
    "class": "fa-toilet",
    "group": "Moradia"
  },
  {
    "name": "Door Open",
    "icon": "door-open",
    "class": "fa-door-open",
    "group": "Moradia"
  },
  {
    "name": "Lightbulb",
    "icon": "lightbulb",
    "class": "fa-lightbulb",
    "group": "Moradia"
  },
  {
    "name": "Plug",
    "icon": "plug",
    "class": "fa-plug",
    "group": "Moradia"
  },
  {
    "name": "Shower",
    "icon": "shower",
    "class": "fa-shower",
    "group": "Moradia"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Moradia"
  },
  {
    "name": "Tools",
    "icon": "tools",
    "class": "fa-tools",
    "group": "Moradia"
  },
  {
    "name": "Paint Roller",
    "icon": "paint-roller",
    "class": "fa-paint-roller",
    "group": "Moradia"
  },
  {
    "name": "Fan",
    "icon": "fan",
    "class": "fa-fan",
    "group": "Moradia"
  },
  {
    "name": "Chair",
    "icon": "chair",
    "class": "fa-chair",
    "group": "Moradia"
  },
  {
    "name": "Hammer",
    "icon": "hammer",
    "class": "fa-hammer",
    "group": "Moradia"
  },
  {
    "name": "Warehouse",
    "icon": "warehouse",
    "class": "fa-warehouse",
    "group": "Moradia"
  },
  {
    "name": "Water",
    "icon": "water",
    "class": "fa-water",
    "group": "Moradia"
  },
  {
    "name": "Fire Extinguisher",
    "icon": "fire-extinguisher",
    "class": "fa-fire-extinguisher",
    "group": "Moradia"
  },
  {
    "name": "Key",
    "icon": "key",
    "class": "fa-key",
    "group": "Moradia"
  },
  {
    "name": "Lock",
    "icon": "lock",
    "class": "fa-lock",
    "group": "Moradia"
  },
  {
    "name": "Film",
    "icon": "film",
    "class": "fa-film",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Gamepad",
    "icon": "gamepad",
    "class": "fa-gamepad",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Futbol",
    "icon": "futbol",
    "class": "fa-futbol",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Headphones",
    "icon": "headphones",
    "class": "fa-headphones",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Theater Masks",
    "icon": "theater-masks",
    "class": "fa-theater-masks",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Music",
    "icon": "music",
    "class": "fa-music",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Book",
    "icon": "book",
    "class": "fa-book",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Camera",
    "icon": "camera",
    "class": "fa-camera",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Chess",
    "icon": "chess",
    "class": "fa-chess",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Dice",
    "icon": "dice",
    "class": "fa-dice",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Guitar",
    "icon": "guitar",
    "class": "fa-guitar",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Play",
    "icon": "play",
    "class": "fa-play",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Ticket Alt",
    "icon": "ticket-alt",
    "class": "fa-ticket-alt",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Puzzle Piece",
    "icon": "puzzle-piece",
    "class": "fa-puzzle-piece",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Palette",
    "icon": "palette",
    "class": "fa-palette",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Microphone",
    "icon": "microphone",
    "class": "fa-microphone",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Laugh",
    "icon": "laugh",
    "class": "fa-laugh",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Bowling Ball",
    "icon": "bowling-ball",
    "class": "fa-bowling-ball",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Drum",
    "icon": "drum",
    "class": "fa-drum",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Book",
    "icon": "book",
    "class": "fa-book",
    "group": "Educação"
  },
  {
    "name": "Graduation Cap",
    "icon": "graduation-cap",
    "class": "fa-graduation-cap",
    "group": "Educação"
  },
  {
    "name": "Chalkboard Teacher",
    "icon": "chalkboard-teacher",
    "class": "fa-chalkboard-teacher",
    "group": "Educação"
  },
  {
    "name": "Pen",
    "icon": "pen",
    "class": "fa-pen",
    "group": "Educação"
  },
  {
    "name": "Pencil Alt",
    "icon": "pencil-alt",
    "class": "fa-pencil-alt",
    "group": "Educação"
  },
  {
    "name": "Highlighter",
    "icon": "highlighter",
    "class": "fa-highlighter",
    "group": "Educação"
  },
  {
    "name": "Laptop",
    "icon": "laptop",
    "class": "fa-laptop",
    "group": "Educação"
  },
  {
    "name": "Microscope",
    "icon": "microscope",
    "class": "fa-microscope",
    "group": "Educação"
  },
  {
    "name": "Atom",
    "icon": "atom",
    "class": "fa-atom",
    "group": "Educação"
  },
  {
    "name": "School",
    "icon": "school",
    "class": "fa-school",
    "group": "Educação"
  },
  {
    "name": "University",
    "icon": "university",
    "class": "fa-university",
    "group": "Educação"
  },
  {
    "name": "User Graduate",
    "icon": "user-graduate",
    "class": "fa-user-graduate",
    "group": "Educação"
  },
  {
    "name": "Notebook",
    "icon": "notebook",
    "class": "fa-notebook",
    "group": "Educação"
  },
  {
    "name": "Glasses",
    "icon": "glasses",
    "class": "fa-glasses",
    "group": "Educação"
  },
  {
    "name": "Calendar Alt",
    "icon": "calendar-alt",
    "class": "fa-calendar-alt",
    "group": "Educação"
  },
  {
    "name": "Paperclip",
    "icon": "paperclip",
    "class": "fa-paperclip",
    "group": "Educação"
  },
  {
    "name": "Folder",
    "icon": "folder",
    "class": "fa-folder",
    "group": "Educação"
  },
  {
    "name": "Ruler",
    "icon": "ruler",
    "class": "fa-ruler",
    "group": "Educação"
  },
  {
    "name": "Compass",
    "icon": "compass",
    "class": "fa-compass",
    "group": "Educação"
  },
  {
    "name": "Abacus",
    "icon": "abacus",
    "class": "fa-abacus",
    "group": "Educação"
  },
  {
    "name": "Heartbeat",
    "icon": "heartbeat",
    "class": "fa-heartbeat",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Stethoscope",
    "icon": "stethoscope",
    "class": "fa-stethoscope",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Medkit",
    "icon": "medkit",
    "class": "fa-medkit",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Pills",
    "icon": "pills",
    "class": "fa-pills",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Syringe",
    "icon": "syringe",
    "class": "fa-syringe",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Tooth",
    "icon": "tooth",
    "class": "fa-tooth",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Spa",
    "icon": "spa",
    "class": "fa-spa",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Dumbbell",
    "icon": "dumbbell",
    "class": "fa-dumbbell",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "First Aid",
    "icon": "first-aid",
    "class": "fa-first-aid",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Soap",
    "icon": "soap",
    "class": "fa-soap",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Thermometer",
    "icon": "thermometer",
    "class": "fa-thermometer",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Band Aid",
    "icon": "band-aid",
    "class": "fa-band-aid",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Apple Alt",
    "icon": "apple-alt",
    "class": "fa-apple-alt",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Lungs",
    "icon": "lungs",
    "class": "fa-lungs",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Brain",
    "icon": "brain",
    "class": "fa-brain",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "User Nurse",
    "icon": "user-nurse",
    "class": "fa-user-nurse",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Hospital",
    "icon": "hospital",
    "class": "fa-hospital",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Vial",
    "icon": "vial",
    "class": "fa-vial",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Weight",
    "icon": "weight",
    "class": "fa-weight",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Tint",
    "icon": "tint",
    "class": "fa-tint",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Shopping Cart",
    "icon": "shopping-cart",
    "class": "fa-shopping-cart",
    "group": "Compras"
  },
  {
    "name": "Shopping Bag",
    "icon": "shopping-bag",
    "class": "fa-shopping-bag",
    "group": "Compras"
  },
  {
    "name": "Store",
    "icon": "store",
    "class": "fa-store",
    "group": "Compras"
  },
  {
    "name": "Tags",
    "icon": "tags",
    "class": "fa-tags",
    "group": "Compras"
  },
  {
    "name": "Credit Card",
    "icon": "credit-card",
    "class": "fa-credit-card",
    "group": "Compras"
  },
  {
    "name": "Cash Register",
    "icon": "cash-register",
    "class": "fa-cash-register",
    "group": "Compras"
  },
  {
    "name": "Receipt",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Compras"
  },
  {
    "name": "Box",
    "icon": "box",
    "class": "fa-box",
    "group": "Compras"
  },
  {
    "name": "Gift",
    "icon": "gift",
    "class": "fa-gift",
    "group": "Compras"
  },
  {
    "name": "Cart Arrow Down",
    "icon": "cart-arrow-down",
    "class": "fa-cart-arrow-down",
    "group": "Compras"
  },
  {
    "name": "Barcode",
    "icon": "barcode",
    "class": "fa-barcode",
    "group": "Compras"
  },
  {
    "name": "Store Alt",
    "icon": "store-alt",
    "class": "fa-store-alt",
    "group": "Compras"
  },
  {
    "name": "Bag Shopping",
    "icon": "bag-shopping",
    "class": "fa-bag-shopping",
    "group": "Compras"
  },
  {
    "name": "Percent",
    "icon": "percent",
    "class": "fa-percent",
    "group": "Compras"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Compras"
  },
  {
    "name": "Money Bill",
    "icon": "money-bill",
    "class": "fa-money-bill",
    "group": "Compras"
  },
  {
    "name": "Price Tag",
    "icon": "price-tag",
    "class": "fa-price-tag",
    "group": "Compras"
  },
  {
    "name": "Dollar Sign",
    "icon": "dollar-sign",
    "class": "fa-dollar-sign",
    "group": "Compras"
  },
  {
    "name": "Coins",
    "icon": "coins",
    "class": "fa-coins",
    "group": "Compras"
  },
  {
    "name": "Exchange Alt",
    "icon": "exchange-alt",
    "class": "fa-exchange-alt",
    "group": "Compras"
  },
  {
    "name": "Briefcase",
    "icon": "briefcase",
    "class": "fa-briefcase",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Money Bill Wave",
    "icon": "money-bill-wave",
    "class": "fa-money-bill-wave",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Chart Line",
    "icon": "chart-line",
    "class": "fa-chart-line",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Hand Holding Usd",
    "icon": "hand-holding-usd",
    "class": "fa-hand-holding-usd",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Business Time",
    "icon": "business-time",
    "class": "fa-business-time",
    "group": "Trabalho e Renda"
  },
  {
    "name": "User Tie",
    "icon": "user-tie",
    "class": "fa-user-tie",
    "group": "Trabalho e Renda"
  },
  {
    "name": "File Invoice",
    "icon": "file-invoice",
    "class": "fa-file-invoice",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Calculator",
    "icon": "calculator",
    "class": "fa-calculator",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Suitcase",
    "icon": "suitcase",
    "class": "fa-suitcase",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Landmark",
    "icon": "landmark",
    "class": "fa-landmark",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Piggy Bank",
    "icon": "piggy-bank",
    "class": "fa-piggy-bank",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Clipboard",
    "icon": "clipboard",
    "class": "fa-clipboard",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Money Check",
    "icon": "money-check",
    "class": "fa-money-check",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Balance Scale",
    "icon": "balance-scale",
    "class": "fa-balance-scale",
    "group": "Trabalho e Renda"
  },
  {
    "name": "File Contract",
    "icon": "file-contract",
    "class": "fa-file-contract",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Chart Pie",
    "icon": "chart-pie",
    "class": "fa-chart-pie",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Id Badge",
    "icon": "id-badge",
    "class": "fa-id-badge",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Project Diagram",
    "icon": "project-diagram",
    "class": "fa-project-diagram",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Users",
    "icon": "users",
    "class": "fa-users",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Hand Holding Usd",
    "icon": "hand-holding-usd",
    "class": "fa-hand-holding-usd",
    "group": "Receita"
  },
  {
    "name": "Money Bill Wave",
    "icon": "money-bill-wave",
    "class": "fa-money-bill-wave",
    "group": "Receita"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Receita"
  },
  {
    "name": "Chart Line",
    "icon": "chart-line",
    "class": "fa-chart-line",
    "group": "Receita"
  },
  {
    "name": "Donate",
    "icon": "donate",
    "class": "fa-donate",
    "group": "Receita"
  },
  {
    "name": "Credit Card",
    "icon": "credit-card",
    "class": "fa-credit-card",
    "group": "Receita"
  },
  {
    "name": "Dollar Sign",
    "icon": "dollar-sign",
    "class": "fa-dollar-sign",
    "group": "Receita"
  },
  {
    "name": "Coins",
    "icon": "coins",
    "class": "fa-coins",
    "group": "Receita"
  },
  {
    "name": "Piggy Bank",
    "icon": "piggy-bank",
    "class": "fa-piggy-bank",
    "group": "Receita"
  },
  {
    "name": "Money Check",
    "icon": "money-check",
    "class": "fa-money-check",
    "group": "Receita"
  },
  {
    "name": "File Invoice Dollar",
    "icon": "file-invoice-dollar",
    "class": "fa-file-invoice-dollar",
    "group": "Receita"
  },
  {
    "name": "Landmark",
    "icon": "landmark",
    "class": "fa-landmark",
    "group": "Receita"
  },
  {
    "name": "User Tie",
    "icon": "user-tie",
    "class": "fa-user-tie",
    "group": "Receita"
  },
  {
    "name": "Money Check Alt",
    "icon": "money-check-alt",
    "class": "fa-money-check-alt",
    "group": "Receita"
  },
  {
    "name": "Receipt",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Receita"
  },
  {
    "name": "Cash Register",
    "icon": "cash-register",
    "class": "fa-cash-register",
    "group": "Receita"
  },
  {
    "name": "Balance Scale",
    "icon": "balance-scale",
    "class": "fa-balance-scale",
    "group": "Receita"
  },
  {
    "name": "Briefcase",
    "icon": "briefcase",
    "class": "fa-briefcase",
    "group": "Receita"
  },
  {
    "name": "Chart Pie",
    "icon": "chart-pie",
    "class": "fa-chart-pie",
    "group": "Receita"
  },
  {
    "name": "Building",
    "icon": "building",
    "class": "fa-building",
    "group": "Receita"
  },
  {
    "name": "Laptop",
    "icon": "laptop",
    "class": "fa-laptop",
    "group": "Tecnologia"
  },
  {
    "name": "Mobile Alt",
    "icon": "mobile-alt",
    "class": "fa-mobile-alt",
    "group": "Tecnologia"
  },
  {
    "name": "Tablet Alt",
    "icon": "tablet-alt",
    "class": "fa-tablet-alt",
    "group": "Tecnologia"
  },
  {
    "name": "Desktop",
    "icon": "desktop",
    "class": "fa-desktop",
    "group": "Tecnologia"
  },
  {
    "name": "Server",
    "icon": "server",
    "class": "fa-server",
    "group": "Tecnologia"
  },
  {
    "name": "Wifi",
    "icon": "wifi",
    "class": "fa-wifi",
    "group": "Tecnologia"
  },
  {
    "name": "Satellite",
    "icon": "satellite",
    "class": "fa-satellite",
    "group": "Tecnologia"
  },
  {
    "name": "Microchip",
    "icon": "microchip",
    "class": "fa-microchip",
    "group": "Tecnologia"
  },
  {
    "name": "Keyboard",
    "icon": "keyboard",
    "class": "fa-keyboard",
    "group": "Tecnologia"
  },
  {
    "name": "Mouse",
    "icon": "mouse",
    "class": "fa-mouse",
    "group": "Tecnologia"
  },
  {
    "name": "Camera",
    "icon": "camera",
    "class": "fa-camera",
    "group": "Tecnologia"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Tecnologia"
  },
  {
    "name": "Code",
    "icon": "code",
    "class": "fa-code",
    "group": "Tecnologia"
  },
  {
    "name": "Cloud",
    "icon": "cloud",
    "class": "fa-cloud",
    "group": "Tecnologia"
  },
  {
    "name": "Database",
    "icon": "database",
    "class": "fa-database",
    "group": "Tecnologia"
  },
  {
    "name": "Network Wired",
    "icon": "network-wired",
    "class": "fa-network-wired",
    "group": "Tecnologia"
  },
  {
    "name": "Robot",
    "icon": "robot",
    "class": "fa-robot",
    "group": "Tecnologia"
  },
  {
    "name": "Usb",
    "icon": "usb",
    "class": "fa-usb",
    "group": "Tecnologia"
  },
  {
    "name": "Ethernet",
    "icon": "ethernet",
    "class": "fa-ethernet",
    "group": "Tecnologia"
  },
  {
    "name": "Sim Card",
    "icon": "sim-card",
    "class": "fa-sim-card",
    "group": "Tecnologia"
  },
{
    "name": "Assinaturas",
    "icon": "file-invoice",
    "class": "fa-file-invoice",
    "group": "Serviços"
  },
  {
    "name": "Contador/Impostos",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Serviços"
  },
  {
    "name": "Multas e taxas",
    "icon": "gavel",
    "class": "fa-gavel",
    "group": "Serviços"
  },
  {
    "name": "Serviços bancários",
    "icon": "university",
    "class": "fa-university",
    "group": "Serviços"
  },
  {
    "name": "Presentes",
    "icon": "gift",
    "class": "fa-gift",
    "group": "Outros"
  },
  {
    "name": "Doações",
    "icon": "hand-holding-heart",
    "class": "fa-hand-holding-heart",
    "group": "Outros"
  },
  {
    "name": "Imprevistos",
    "icon": "exclamation-triangle",
    "class": "fa-exclamation-triangle",
    "group": "Outros"
  }
]



const getIcons = async () => {

    let mapped_groups = {};

    icons_new.forEach((item) => {

        if(mapped_groups[item.group]){

            mapped_groups[item.group].push(item);

        }
        else{
            mapped_groups[item.group] = [];
            mapped_groups[item.group].push(item);
        }

    });

    icons = mapped_groups;

}

const getExpenseCategories = async () => {

    axios.get('categories?type=despesa')
    .then(res => {
        
        if(res.status == 200){

            store.state.categoriesExpense = res.data;
            store.state.loadingCategoriesExpense = false;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getRevenueCategories = async () => {

axios.get('categories?type=receita')
.then(res => {
    
    if(res.status == 200){

        store.state.categoriesRevenue = res.data;
        store.state.loadingCategoriesRevenue = false;

    }
    
})
.catch(err => {
    console.error(err); 
})

}

const colors = [
    "#FFB3B3", "#FFCCBC", "#FFECB3", "#FFF9C4", "#DCEDC8", "#C8E6C9",
    "#B2EBF2", "#B3E5FC", "#B2DFDB", "#D1C4E9", "#E1BEE7", "#F8BBD0",
    "#EF9A9A", "#FFAB91", "#FFD180", "#FFF59D", "#AED581", "#81C784",
    "#4DB6AC", "#4FC3F7", "#64B5F6", "#7986CB", "#BA68C8", "#F06292",
    "#E57373", "#F48FB1", "#CE93D8", "#9575CD", "#7986CB", "#4FC3F7",
    "#4DD0E1", "#4DB6AC", "#81C784", "#AED581", "#FFF176", "#FFD54F",
    "#FFB74D", "#FF8A65", "#A1887F", "#E0E0E0", "#90A4AE", "#A5D6A7",
    "#C5E1A5", "#E6EE9C", "#FFF176", "#FFD54F", "#FFB74D", "#FF8A65",
    "#FF7043", "#8D6E63", "#BDBDBD", "#78909C", "#F44336", "#E91E63",
    "#9C27B0", "#673AB7", "#3F51B5", "#03A9F4", "#009688", "#4CAF50"
  ]

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

onBeforeMount(() => {

    validSession.isLogged();

    store.state.categoriesExpense = {};
    store.state.categoriesRevenue = {};

    store.state.category_icon = 'fa-receipt';
    store.state.category_color = '#000'
    store.state.category_name = '';
    store.state.category_type = '';
    store.state.category_sub = false;
    store.state.category_parent = 0;
    store.state.category_id = '';

    store.state.validation = {
        nameHasError: false,
        nameMessageError: '',
        parentHasError: false,
        parentMessageError: '',
    };

    store.state.loadingCategoriesExpense = true;
    store.state.loadingCategoriesRevenue = true;

    store.state.deleted_category = {};
    store.state.destiny_category = 0;

    getIcons();
    getExpenseCategories();
    getRevenueCategories();
});

const createCategory = (type) => {

    if(type == 'despesa'){
        selectCategories = store.state.categoriesExpense;
    }
    else{
        selectCategories = store.state.categoriesRevenue;
    }

    store.state.category_type = type;

}

const editCategory = (data) => {

    createCategory(data.type);

    store.state.category_icon = data.icon;
    store.state.category_color = data.color
    store.state.category_name = data.name;
    store.state.category_type = data.type;
    store.state.category_sub = data.sub == 'Yes' ? true : false;
    store.state.category_parent = data.parent_id;
    store.state.category_id = data.id;

}

const clearFields = () => {
    store.state.category_icon = 'fa-receipt';
    store.state.category_color = '#000'
    store.state.category_name = '';
    store.state.category_type = '';
    store.state.category_sub = false;
    store.state.category_parent = '';
    store.state.category_id = '';
}

const openModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.show();

}

const closeModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.hide();

}

const submit_category = async () => {

    let data = new FormData();

    store.state.validation.nameHasError = false;
    store.state.validation.parentHasError = false;

    data.append('name', store.state.category_name);
    data.append('icon', store.state.category_icon);
    data.append('color', store.state.category_color);
    data.append('type', store.state.category_type);
    data.append('sub', store.state.category_sub == true ? 'Yes' : '');
    data.append('parent_id', store.state.category_sub == true ? store.state.category_parent : 0);

    let url = '/categories';
    let toast_message = t('message.categories.created');

    if(store.state.category_id != ''){
        url = '/categories/update/'+store.state.category_id;
        toast_message = t('message.categories.updated');
    }

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'name'){
                    store.state.validation.nameHasError = true;
                    store.state.validation.nameMessageError = value[1];
                }

                else if(value[0] == 'parent_id'){
                    store.state.validation.parentHasError = true;
                    store.state.validation.parentMessageError = value[1];
                }


            })

        }
        else{

            let type = store.state.category_type;

            store.state.validation = {
                nameHasError: false,
                nameMessageError: '',
                parentHasError: false,
                parentMessageError: '',
            };

            closeModal('addCategoryModal');

            clearFields();

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });
            
            if(type == 'despesa'){
                getExpenseCategories();
            }
            else if(type == 'receita'){
                getRevenueCategories();
            }

        }

    })
    .catch(err => {
    console.error(err); 
    })

}

const archiveCategory = async (category, archive) => {

    if(archive == 'Yes'){

        if(category.subs && category.subs.length > 0){
            openModal('hasSubModal');
            return;
        }

        openModal('confirmArchiveCategoryModal');

        var confirmButton = document.getElementById('confirmArchiveButton');
        confirmButton.addEventListener('click', async function () {
        // do something...
        
            let data = new FormData();

            data.append('archived', archive);

            let url = '/categories/archive/'+category.id;
            let toast_message = t('message.categories.archived');

            if(archive == 'No'){
                toast_message = t('message.categories.desarchived');;
            }

            await axios.post(url, data)
            .then(res => {

                if(res.data.error){

                    console.log(res);

                }
                else{

                    toast(toast_message, {
                        autoClose: 1000,
                        theme: "auto",
                        type: "success",
                        transition: "slide"
                    });

                    closeModal('confirmArchiveCategoryModal');
                    
                    if(category.type == 'despesa'){
                        getExpenseCategories();
                    }
                    else if(category.type == 'receita'){
                        getRevenueCategories();
                    }

                }

            })
            .catch(err => {
            console.error(err); 
            })
            

        })

    }
    else{

        let data = new FormData();

        data.append('archived', archive);

        let url = '/categories/archive/'+category.id;
        let toast_message = t('message.categories.archived');

        if(archive == 'No'){
            toast_message = t('message.categories.desarchived');
        }

        await axios.post(url, data)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });
                
                if(category.type == 'despesa'){
                    getExpenseCategories();
                }
                else if(category.type == 'receita'){
                    getRevenueCategories();
                }

            }

        })
        .catch(err => {
        console.error(err); 
        })

    }    

}

const deleteCategory = async (category) => {

    store.state.deleted_category = category

    if(category.type == 'despesa'){

        let categories = Object.entries(store.state.categoriesExpense);

        for(let i = 0; i <= categories.length - 1; i++){

            if(categories[i][1].id != category.id){

                selectCategoriesMove.push({
                    id: categories[i][1].id,
                    name: categories[i][1].name
                });

                if(categories[i][1].subs){

                    let subs = categories[i][1].subs;

                    for(let s = 0; s <= subs.length - 1; s++){

                        if(subs[s].id != category.id){

                            selectCategoriesMove.push({
                                id: subs[s].id,
                                name: subs[s].name,
                                sub: true
                            });

                        }

                    }

                }

            }

        }

    }
    else if(category.type == 'receita'){

        let categories = Object.entries(store.state.categoriesRevenue);

        for(let i = 0; i <= categories.length - 1; i++){

            if(categories[i][1].id != category.id){

                selectCategoriesMove.push({
                    id: categories[i][1].id,
                    name: categories[i][1].name
                });

                if(categories[i][1].subs){

                    let subs = categories[i][1].subs;

                    for(let s = 0; s <= subs.length - 1; s++){

                        if(subs[s].id != category.id){

                            selectCategoriesMove.push({
                                id: subs[s].id,
                                name: subs[s].name,
                                sub: true
                            });

                        }

                    }

                }

            }

        }

    }

    openModal('deleteCategoryModal');

    var confirmButton = document.getElementById('confirmExclusionCategoryButton');
    confirmButton.addEventListener('click', async function () {
    // do something...
    
        let data = new FormData();

        data.append('before', category.id);
        data.append('after', store.state.destiny_category);

        let url = '/categories/delete';
        let toast_message = t('message.categories.deleted');

        await axios.post(url, data)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                closeModal('deleteCategoryModal');
                
                if(category.type == 'despesa'){
                    getExpenseCategories();
                }
                else if(category.type == 'receita'){
                    getRevenueCategories();
                }

            }

        })
        .catch(err => {
        console.error(err); 
        })
        

    })

}

const getContrastYIQ = (hexcolor) => {
    var r = parseInt(hexcolor.substring(1,3),16);
    var g = parseInt(hexcolor.substring(3,5),16);
    var b = parseInt(hexcolor.substring(5,7),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
}

</script>

<template>
    <div class="py-4 container-fluid overflow-auto max-height-vh-90">
        <div class="row">
            <div class="col-12">

                <div class="card">
                    <div class="card-header pb-0">
                        <div class="row align-items-center mb-n2 mb-md-2 mt-md-n2">
                            <div class="col-6">
                                <h6 class="text-white">{{ t('message.menu.category', 2) }}</h6>
                            </div>
                            <div class="col-6">
                                <div class="dropdown float-end">
                                    <a class="me-3 trasation-list-add-button mt-n1 mb-2 text-white" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fal fa-plus-circle"></i> <span class="d-none d-lg-inline-flex">{{ t('message.global.add') }}</span>
                                    </a>
                                    <ul class="dropdown-menu dropdown-menu-end text-center" aria-labelledby="dropdownMenuButton1">
                                        <li>
                                            <a class="dropdown-item" :class="darkMode ? 'darkmode' : ''" data-bs-toggle="modal" data-bs-target="#addCategoryModal" @click="createCategory('despesa')">{{ t('message.categories.creation_expense') }}</a>
                                        </li>
                                        <li><a class="dropdown-item" :class="darkMode ? 'darkmode' : ''" data-bs-toggle="modal" data-bs-target="#addCategoryModal" @click="createCategory('receita')">{{ t('message.categories.creation_revenue') }}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body px-0 pt-0 pb-2">
                        <div class="col-12">

                            <div class="row">

                                <div class="col-11 mx-auto mt-3 mb-3">

                                    <ul class="nav nav-tabs justify-content-center no-border" id="categories-tab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active despesa" :class="darkMode ? 'darkmode' : ''" id="out-categorie-tab" data-bs-toggle="tab" data-bs-target="#out-categorie" type="button" role="tab" aria-controls="out-categorie" aria-selected="true">{{ t('message.global.expense', 2) }}</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" :class="darkMode ? 'darkmode' : ''" id="in-categorie-tab" data-bs-toggle="tab" data-bs-target="#in-categorie" type="button" role="tab" aria-controls="in-categorie" aria-selected="false">{{ t('message.global.revenue', 2) }}</button>
                                        </li>
                                    </ul>

                                    <div class="tab-content" id="myTabContent">
                                        <div class="tab-pane fade show active mt-3" id="out-categorie" role="tabpanel" aria-labelledby="out-categorie-tab">

                                            <div class="col-12 text-center mt-4" v-if="store.state.loadingCategoriesExpense">
                                                <img :src="loadGif" alt="" width="60px">
                                            </div>

                                            <div class="col-12 text-center mt-4" v-if="store.state.categoriesExpense.length == 0">
                                                <p>{{ t('message.global.zero_categories') }}</p>
                                            </div>

                                            <CategoriesRow
                                                v-for="(category, index) in store.state.categoriesExpense" :key="index"
                                                :name="category.name"
                                                :id="category.id"
                                                :icon="category.icon"
                                                :color_icon="category.color"
                                                :subs="category.subs"
                                                :edit="category"
                                                :darkmode="darkMode"
                                                @edit="editCategory"
                                                @archive="archiveCategory"
                                                @delete="deleteCategory"
                                            />

                                        </div>
                                        <div class="tab-pane fade" id="in-categorie" role="tabpanel" aria-labelledby="in-categorie-tab">

                                            <div class="col-12 text-center mt-4" v-if="store.state.loadingCategoriesRevenue">
                                                <img :src="loadGif" alt="" width="60px">
                                            </div>

                                            <div class="col-12 text-center mt-4" v-if="store.state.categoriesRevenue.length == 0">
                                                <p>{{ t('message.global.zero_categories') }}</p>
                                            </div>

                                            <CategoriesRow
                                                v-for="(category, index) in store.state.categoriesRevenue" :key="index"
                                                :name="category.name"
                                                :id="category.id"
                                                :icon="category.icon"
                                                :color_icon="category.color"
                                                :subs="category.subs"
                                                :edit="category"
                                                :darkmode="darkMode"
                                                @edit="editCategory"
                                                @archive="archiveCategory"
                                                @delete="deleteCategory"
                                            />

                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="modal fade" id="addCategoryModal" tabindex="-1" aria-labelledby="addCategoryModalLabel" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-10">
                            <b v-if="store.state.category_id == ''">
                                {{ store.state.category_type == 'despesa' ? t('message.categories.new_expense') : t('message.categories.new_renew')}}
                            </b>
                            <b v-else>
                                {{ store.state.category_type == 'despesa' ? t('message.categories.edit_expense') : t('message.categories.edit_renew')}}
                            </b>
                        </div>

                        <div class="col-2 text-end">
                            <a type="button" data-bs-dismiss="modal" @click="clearFields()">
                                <i class="fal fa-times-circle fa-lg"></i>
                            </a>
                        </div>

                        <div class="col-11 mx-auto">

                            <div class="row align-items-center mt-5">
                                <div class="col-3 category-create-icon-div">

                                    <div class="text-center shadow icon icon-shape align-self-center rounded-5 ms-2 me-3" :style="'background-color: '+store.state.category_color">
                                        <i :class="'icon-create fal ' + store.state.category_icon" :style="'color:'+getContrastYIQ(store.state.category_color)"></i>
                                    </div>

                                </div>
                                <div class="col-9 mb-3">

                                    <label for="categoryName">{{ t('message.categories.name') }}</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="categoryName"
                                        name="categoryName"
                                        :placeholder="t('message.categories.name')"
                                        v-model="store.state.category_name"
                                        v-bind:class="{
                                            'is-invalid': store.state.validation.nameHasError,
                                            'darkmode': darkMode,
                                        }"
                                    >
                                    <div id="categoryNameFeedback" class="invalid-feedback">
                                        {{ store.state.validation.nameMessageError }}
                                    </div>
                                    

                                </div>
                                <div class="col-12 mb-1">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="store.state.category_sub">
                                        <label class="form-check-label" for="flexCheckDefault">
                                            {{ t('message.categories.subcategory') }}
                                        </label>
                                    </div>
                                </div>
                                <div v-if="store.state.category_sub" class="col-12 mb-3">
                                    <label for="categoryName">{{ t('message.categories.category_parent') }}</label>
                                    <select 
                                        class="form-select form-select-lg" 
                                        aria-label="Categoria Pai" 
                                        v-model="store.state.category_parent"
                                        :class="store.state.validation.parentHasError ? 'is-invalid' : ''"
                                        id="parentSelect"
                                    >
                                            <option value="0" selected disabled>{{ t('message.categories.select_parent') }}</option>
                                            <option
                                                v-for="(category, index) in selectCategories" :key="index"
                                                :value="category.id"
                                            >
                                                {{ category.name }}
                                            </option>
                                    </select>
                                    <div id="parentSelectFeedback" class="invalid-feedback">
                                        {{ store.state.validation.parentMessageError }}
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <hr>
                            </div>

                            <div class="row">

                                <div class="col-12">
                                    <p>{{ t('message.global.choose_icon') }}</p>
                                </div>

                                <div class="col-12 icon-list">

                                    <div class="row justify-content-center">

                                        <div v-for="(groups, index) in icons" :key="index" class="col-12">
                                            <div class="col-12">
                                                <span class="text-xs font-weight-bold">{{ index }}</span>
                                            </div>
                                            <div class="col-12">

                                                <div class="row">

                                                    <div
                                                        v-for="(icon, i) in groups" :key="i"
                                                        @click="() => { store.state.category_icon = icon.class;}"
                                                        class="color-picker rounded-5 d-flex align-items-center"
                                                        :class="darkMode ? 'text-white' : 'text-dark'"
                                                    >
                                                        <i :class="'ms-n1 fal '+icon.class"></i>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>


                                    </div>

                                </div>
                                
                            </div>

                            <div class="row mt-2 mb-2">
                                <hr>
                            </div>

                            <div class="row">

                                <div class="col-12">
                                    <p>{{ t('message.global.choose_color') }}</p>
                                </div>

                                <div class="col-12 icon-list">

                                    <div class="row">

                                        <div
                                            v-for="(color, index) in colors" :key="index"
                                            @click="store.state.category_color = color"
                                            class="color-picker rounded-5" 
                                            :style="'background-color: '+color+';'"
                                            ></div>

                                    </div>

                                </div>
                                
                                
                            </div>

                            <div class="row mt-2 mb-2">
                                <hr>
                            </div>

                            <div class="row">
                                <div class="col-12 mt-3 mb-3 text-center">
                                    <button 
                                        @click="submit_category()"
                                        class="btn btn-success"
                                    >
                                        {{ store.state.category_id == '' ? t('message.categories.add') : t('message.categories.update') }}
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="confirmArchiveCategoryModal" tabindex="-1" aria-labelledby="confirmArchiveCategoryModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-11 mx-auto mt-4 mb-4 text-center">
                            <h4 class="mb-4">{{ t('message.categories.archive_title') }}</h4>
                            <p v-html="t('message.categories.archive_disclaim')">
                                
                            </p>
                        </div>
                        <div class="col-12 text-center">
                            <button
                                id="confirmArchiveButton" 
                                class="btn btn-success"
                            >
                                {{ t('message.categories.archive_button') }}
                            </button>

                            <a @click="closeModal('confirmArchiveCategoryModal')" class="btn btn-link">{{ t('message.global.cancel') }}</a>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="hasSubModal" tabindex="-1" aria-labelledby="hasSubModalModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-11 mx-auto mt-4 mb-4 text-center">
                            <h4 class="mb-4">{{ t('message.categories.sub_title') }}</h4>
                            <p v-html="t('message.categories.sub_disclaim')">
                                
                            </p>
                        </div>
                        <div class="col-12 text-center">
                            <button
                                @click="closeModal('hasSubModal')"
                                class="btn btn-success"
                            >
                                {{ t('message.categories.sub_button') }}
                            </button>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="deleteCategoryModal" tabindex="-1" aria-labelledby="deleteCategoryModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-11 mx-auto mt-4 mb-2 text-center">
                            <h4 class="mb-4">{{ t('message.categories.delete_title') }}</h4>
                            
                        </div>
                        <div class="col-11 mx-auto">
                            <div class="mb-3">
                                <label for="category_delete" class="form-label">{{ t('message.categories.delete_from') }}</label>
                                <input type="text" class="form-control form-control-lg" id="category_delete" readonly v-model="store.state.deleted_category.name">
                            </div>
                            <div class="mb-3">
                                <label for="category_delete_select" class="form-label">{{ t('message.categories.delete_to') }}</label>
                                <select v-model="store.state.destiny_category" name="category_delete_select" id="category_delete_select" class="form-control form-control-lg">
                                    <option value="0" selected>{{ t('message.categories.select_category') }}</option>
                                    <option
                                        v-for="(category, index) in selectCategoriesMove" :key="index"
                                        :value="category.id"
                                    >
                                        {{category.sub ? '==>  ' : '' }}{{category.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button
                                id="confirmExclusionCategoryButton"
                                @click="closeModal('hasSubModal')"
                                class="btn btn-danger text-white"
                                :class="store.state.destiny_category == 0 ? 'disabled' : ''"
                            >
                                {{ t('message.categories.delete_button') }}
                            </button>
                            <a @click="closeModal('deleteCategoryModal')" class="btn btn-link">{{ t('message.global.cancel') }}</a>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<style>
    .configuration-button{
        text-align: start !important;
    }
    .no-border{
        border: none !important;
    }
    #categories-tab .nav-link.active{
        border-bottom: 2px solid #20c997 !important;
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
    }

    #categories-tab .nav-link.despesa.active{
        border-bottom: 2px solid #f5365c !important;
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
    }

    #categories-tab .nav-link{
        border: none !important;
        color:#000
    }

    #categories-tab .nav-link.darkmode{
        border: none !important;
        color:#fff
    }

    #categories-tab .nav-link.active.darkmode{
        border-bottom: 2px solid #20c997 !important;
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        background-color: rgba(255, 255, 255, 0.13);
    }

    #categories-tab .nav-link.active.despesa.darkmode{
      border-bottom: 2px solid #f5365c !important;
      background-color: rgba(255, 255, 255, 0.13);
    }

    .category-create-icon-div{
        height: 85px;
    }

    .category-create-icon{
        min-height: 100%;
    }

    .color-picker{
        margin: 2px 4px 2px 0;
        width: 43px !important;
        height: 43px !important;
        cursor: pointer;
        font-size: 22px;
    }

    .color-picker .active{
        border: 4px solid #cecece;
    }

    .icon-picker{
        margin: 2px 4px 2px 0;
        width: 43px !important;
        height: 43px !important;
        cursor: pointer;
    }

    .icon-create{
        font-size: 20px !important;
    }

    .icon-list{
        height: 150px;
        overflow-x:auto;
    }

    .modal-body.darkmode{
        background-color: #3d3d3d !important;
    }

    .dark-version .dropdown .dropdown-menu{
        background: #3d3d3d !important;
    }

    .dropdown-item.darkmode{
        color: #fff !important;
    }

    @media (max-width: 575.98px) {

        .category-create-icon-div{
            height: 60px;
        }
    }
</style>
